module.exports = __webpack_public_path__ + "static/media/electric-panel.b745fc5c.png";